<div class="row toasts py-1 mt-1">
  <div class="col">
    @for (toast of toastService.toasts; track toast) {
      <ngb-alert [type]="toast.type" (closed)="toastService.remove(toast)">{{ toast.message }}</ngb-alert>
    }
  </div>
</div>
